const promisify = async (promise) => {
  return new Promise((resolve) => {
    promise
      .then((data) => resolve([data, null]))
      .catch((error) => resolve([null, error]));
  });
};

export default promisify;
